





































































import { isMobile, isTablet } from "@zoovu/design-system/src/helpers";
import { Component, InjectComponent, Prop, Question, QuestionType, Vue, VueComponent } from "@zoovu/runner-browser-api";
import {
  FilterQuestionView,
  FilterCheckboxAnswerView,
  FilterRadioButtonAnswerView,
} from "@zoovu/runner-web-design-base";
import { sanitize } from "dompurify";
import Vuebar from "vuebar";
import TooltipService from "../services/tooltip-service";
import { IconChevron } from "./svgs";
import { whitelistedAttributes } from "../types";

Vue.use(Vuebar);

@Component({
  components: { IconChevron },
  name: "FilterQuestionView",
  mixins: [FilterQuestionView],
})
export default class FilterQuestionViewExtended extends Vue {
  @InjectComponent("Modal")
  modal: VueComponent;

  @InjectComponent("FilterCheckboxAnswerView")
  filterCheckboxAnswer!: VueComponent;

  @InjectComponent("FilterRadioButtonAnswerView")
  filterRadioButtonAnswer!: VueComponent;

  @Prop()
  private question: Question;

  isMobile: boolean = isMobile();

  isTablet: boolean = isTablet();

  questionType = QuestionType;

  infoTextShown = false;

  get containerDivId(): string {
    return `#${this.$root.containerDivId} > div`;
  }

  mounted(): void {
    if (this.question.infoText && !this.isMobile && !this.isTablet) {
      TooltipService.createTooltip(`#${this.question.mid} p > .info-text-trigger`, {
        content: sanitize(this.question.infoText, { ADD_ATTR: whitelistedAttributes }),
        trigger: "mouseenter",
        placement: "top",
        distance: 10,
      });
    }
  }

  clickOnInfoText(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    if (!this.isMobile && !this.isTablet) return;
    this.showInfoText();
  }

  getComponentByQuestionType(questionType: QuestionType): Vue {
    return questionType === QuestionType.CHECKBOX
      ? (this.filterCheckboxAnswer as FilterCheckboxAnswerView)
      : (this.filterRadioButtonAnswer as FilterRadioButtonAnswerView);
  }

  onInfoTextTriggerClick(): void {
    if (!this.isMobile && !this.isTablet) return;
    this.showInfoText();
  }

  showInfoText(): void {
    this.infoTextShown = true;
  }

  hideInfoText(): void {
    this.infoTextShown = false;
  }

  toggleShowAllAnswers(): void {
    this.showAllAnswers = !this.showAllAnswers;
  }

  triggerClass(): string {
    return `question-info-text-trigger question-info-text-trigger-${this.question.id}`;
  }
}
